<template>
<div>
  <van-nav-bar
      title="会员中心"
      left-text=""
      left-arrow
      @click-left="onClickLeft()">
  </van-nav-bar>
  <div class="arrow_box">
    <div style="margin-top:2%;">
      <van-swipe :loop="false" :width="390" :show-indicators="true">
        <van-swipe-item>
          <div>
            <img src="../../assets/draw2024/level_1.png" style="width:100%" />
          </div>
          <div>
            <img src="../../assets/draw2024/prize_1.png" style="width:100%" />
          </div>
          <div style="text-align:center;">
            <img src="../../assets/draw2024/receive.png" style="width:50%;height:55px;" @click="receive(1)" />
          </div>
          <!-- <van-button round type="danger" size="large" @click="receive(1)" style="height:35px;">一键领取</van-button> -->
        </van-swipe-item>
        <van-swipe-item>
          <div>
            <img src="../../assets/draw2024/level_5.png" style="width:100%" />
          </div>
          <div>
            <img src="../../assets/draw2024/prize_5.png" style="width:100%" />
          </div>
          <div style="text-align:center;">
            <img src="../../assets/draw2024/receive.png" style="width:50%;height:55px;" @click="receive(2)" />
          </div>
          <!-- <van-button round type="danger" size="large" @click="receive(2)" style="height:35px;">一键领取</van-button> -->
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</div>
  
</template>
<script>
import { Button, NavBar, Image, Swipe, SwipeItem } from "vant";
export default {
  data() {
    return {
      
    };
  },
  created() {
    console.log(this.$route)
    if(this.$route.params.fromWechat){
      this.$router.go(0);
    }
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    receive(id) {
      var that = this;
      that.$http.get("SDWorker/GetActivityPeriod2024", {
          params: {
            taskId:id,
            period:1
          },
        }).then((res) => {
          if (res.data == "success") {
            that.$toast("领取成功！");   
          } else {
            that.$toast(res.data);
          }
        });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
};
</script>
<style scoped>
.arrow_box {
  width: 100%;
  height: 100%;
  background: white;
  position: relative;
  margin-top: 10px;
  background: url('../../assets/draw2024/level_bg.jpg');
  background-repeat:no-repeat;
  overflow: hidden;
  background-size: cover;
}


.image
{
  width:177px;
  height:35px;
  position:relative; 
}

@keyframes flicker{
0%,100%{
transform:scale(1);
-moz-transform:scale(1);
-o-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
opacity:1
}
90%{
transform:scale(0.9);
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
opacity:1
}

}
@-webkit-keyframes flicker{
0%,100%{
-webkit-transform:scale(1);
-moz-transform:scale(1);
-o-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-webkit-transform:scale(0.9);
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
@-moz-keyframes flicker{
0%,100%{
-moz-transform:scale(1);
-o-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
@-o-keyframes flicker{
0%,100%{
-o-transform:scale(1);
-moz-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-o-transform:scale(0.9);
-moz-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
.image {
-webkit-animation:flicker 0.8s infinite ease-in-out;
-moz-animation:flicker 0.8s infinite ease-in-out;
-o-animation:flicker 0.8s infinite ease-in-out;
animation:flicker 0.8s infinite ease-in-out
}
.image {
animation-delay:-0.8s;
-webkit-animation-delay:-0.8s;
-moz-animation-delay:-0.8s;
-o-animation-delay:-0.8s
}
/* .arrow{
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent rgba(255, 255, 255, 1) transparent;
  position: absolute;
  bottom: 0px;
  left: 80px;
} */
</style>
